module.exports = __webpack_public_path__ + "img/isnot-set.57fed985.svg";